import React, { useState, useEffect,  useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { debounce } from "underscore";
import {
  STATE_LIST,
  UPLOAD_FILE,
  AGENCY_URL,
  AGENCY_LIST,
  AGENCY_UPDATE_URL,
} from "../../../constants/ApiPaths";
import { ADMIN_AGENCY_ROUTE } from "../../../constants/RoutePaths";
import {
  Container,
  Row,
  Col,
  Button,
  Tooltip,
  InputGroupText,
  Card,
  Form,
  FormGroup,
  Label,
  Input,
  FormFeedback,
  InputGroup,
} from "reactstrap";
import { authHeader } from "../../../functions/CoreFunctions";
import API from "../../../redux/actions/API";
import AgencyImage from "../../../constants/Images/defaultAgency-1.png";
import { CustomAlertMessage } from "../../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import {  NUMBER_REGEX, SOME } from "../../../constants/ValidationRegex";
import CustomPageLoading from "../../CustomComponents/CustomPageLoading";
import BackButtonSvg from "../../common/BackButtonSvg";
import { Info } from "../../common/Info";
import { useParams } from "react-router";
//CreatedBy

//intial Values
const intialValues = {
  agencyName: "",
  agencyEmail: "",
  phoneNumber: "+1 ",
  agencyFax: "",
  address: "",
  city: "",
  zip: "",
  // locationCode: "",
  // createdBy: localStorage.getItem(PAY_PUP_LS_AUTH_USER_ID),
  ttid: "",
  taxId: "",
  verificationDocument: "",
  agencyLogo: "",
  stateId: "",
  routingNumber: "",
  agencyUrl: "",
  // noOfDogPerUser: "",
  // kennelLicenceCount: "",
  renewalNotifiation: "",
  autoApproval: false,
  accountNumber: "",
  accountHolderName: "",
  ifscCode: "",
  bankAddress: "",
};

// validation schema
Yup.addMethod(Yup.string, "phoneNumberValidation", function (errorMessage) {
  return this.test(`test-card-type`, errorMessage, function (value) {
    const { path, createError } = this;
    if (value) {
      let v1 = value;
      if (value.includes("+1 ")) {
        v1 = value.split("+1 ")[1];
      } else {
        // Handle the case where "+1 " is not present
        v1 = value;
      }

      var num = v1.replace(/\D+/g, "");
      var check = v1.match(/[A-Za-z_@./#&+!^*+=,:;]/) ? false : true;
      let Pass = num.length <= 10;
      return (check && Pass) || createError({ path, message: errorMessage });
    } else {
      return createError({ path, message: "Phone Number is Required" });
    }
  });
});

const validationSchema = Yup.object({
  agencyName: Yup.string().required("Agency name is required!"),
  agencyEmail: Yup.string()
    .email("Agency Email must be a valid email")
    .required("Agency Email is required!"),
  phoneNumber: Yup.string().phoneNumberValidation("Invalid Phone Number"),

  // agencyFax: Yup.string().required("Fax is required!"),
  address: Yup.string().required("Address is required!"),
  city: Yup.string().required("City is required!"),
  zip: Yup.string()
    .matches(NUMBER_REGEX, "Zip is not valid")
    .max(6, "Zip is not valid")
    .required("Zip is required!"),
  accountNumber: Yup.string()
    .matches(NUMBER_REGEX, "Account Number must be Number")
    .required("Account Number is required!"),
  accountHolderName: Yup.string().required("Account Holder name is required!"),
  // ifscCode: Yup.string().min(9,"IFSC Code is not Valid").max(9,"IFSC Code is not Valid").required("IFSC code is required!"),
  bankAddress: Yup.string().required("Bank address is required!"),
  // ttid: Yup.string()
  //   .matches(NUMBER_REGEX, "Location Code must be Number")
  //   .required("Location Code is required!"),
  taxId: Yup.string()
    .min(9, "Tax ID is not Valid")
    .max(9, "Tax ID is not Valid")
    .required("Tax ID is required!"),
  stateId: Yup.string().required("State is Required!"),
  agencyUrl: Yup.string()
    .matches(SOME, "Invalid URL")
    .required("Customer Portal URL is required!"),
  // kennelLicenceCount: Yup.number()
  //   .min(1, "Kennel Licence Count atleast one")
  //   .positive("Kennel Licence Count can't start with a minus")
  //   .typeError("Kennel Licence Count must be Numbers")
  //   .integer("Renewal Notificationcan't include a decimal point")
  //   .required("Kennel License Count is required!"),
  routingNumber: Yup.string()
    .min(9, "Routing Number is not Valid")
    .max(9, "Routing Number is not Valid")
    .required("Routing Number is required!"),

  renewalNotifiation: Yup.number()
    .min(1, "Renewal Notification atleast one day")
    .positive("Renewal Notification can't start with a minus")
    .typeError("Renewal Notification must be Numbers")
    .integer("Renewal Notification can't include a decimal point")
    .required("Renewal Notification is required!"),
});

export default function AgencyUpdate(props) {
  const { agencyid } = useParams();
  //history
  const history = useNavigate();
  //for state list
  const [stateList, setStateList] = useState([]);
  //for file upload
  
  //searchString
  const [searchString, setSearchString] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [flag, setflag] = useState(true);
  const [Loading, setLoading] = useState(false);
  const [id, setid] = useState("");
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [callApiCount, setCallApiCount] = useState(0);
  const [customerErrorMsg, setCustomerErrorMsg] = useState(""); 

  const toggle = (id) => {
    setid(id);
    setTooltipOpen(!tooltipOpen);
  };
  //handleSearch
  const handleSearch = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setSearchString(value);
  };

  //fileChange
  // const fileChange = async (e, setFieldValue) => {
  //   e.preventDefault();
  //   const selectedFile = e.target.files[0];
  //   if (selectedFile) {
  //     const formDatas = new FormData();
  //     formDatas.append("file", selectedFile);
  //     const config = {
  //       method: "POST",
  //       url: UPLOAD_FILE,
  //       headers: authHeader(),
  //       data: formDatas,
  //     };
  //     try {
  //       const response = await API(config);
  //       const { status, filepath } = response.data;
  //       if (status === "Success") {
  //         setFieldValue("verificationDocument", filepath);
  //       }
  //     } catch (error) {
  //        if (error.response) {
  //   let { data } = error.response;
  //   CustomAlertMessage(data.message, "error", enqueueSnackbar);
  // }
  //     }
  //   }
  // };

  //post form values
  const postFormData = async (values) => {
    // values["createdBy"] = localStorage.getItem(PAY_PUP_LS_AUTH_USER_ID);
    console.log("header", authHeader());
    const config = {
      method: "PUT",
      url: AGENCY_UPDATE_URL,
      headers: authHeader(),
      data: {
        ...values,
        agencyId: parseInt(agencyid),
        phoneNumber: values.phoneNumber.includes("+1")
          ? values.phoneNumber.split("+1 ")[1]
          : values.phoneNumber,
      },
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        history(ADMIN_AGENCY_ROUTE);
        CustomAlertMessage(
          "Agency Updated Successfully.",
          "success",
          enqueueSnackbar
        );
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    }
  };

  //for state list
  useEffect(() => {
    fetchStateList();
  }, []);

  //get list of state
  const fetchStateList = async () => {
    const config = {
      method: "GET",
      url: STATE_LIST,
      headers: authHeader(),
    };
    try {
      const response = await API(config);
      const { status } = response.data;
      if (status === "Success") {
        const { data } = response.data;
        setStateList(data);
      }
    } catch (error) {}
  };

  // useFormik
  const {
    values,
    handleChange,
    handleSubmit,
    touched,
    setValues,
    errors,
    handleBlur,
    setFieldValue,
    setFieldError,
    setFieldTouched,
  } = useFormik({
    initialValues: intialValues,
    enableReinitialize: true,
    onSubmit: (values) => {
      postFormData(values);
    },
    validationSchema,
    setCustomerErrorMsg,
  });

  // values
  const {
    agencyName,
    agencyEmail,
    phoneNumber = "+1 ",
    agencyFax,
    address,
    city,
    zip,
    ttid,
    taxId,
    agencyLogo,
    stateId,
    renewalNotifiation,
    autoApproval,
    accountNumber,
    routingNumber,
    accountHolderName,
    bankAddress,
  } = values;

  //urlExist
  const getSearchData = async (searchString) => {
    const config = {
      method: "POST",
      url: AGENCY_URL,
      headers: authHeader(),
      data: { agencyId: agencyid, agencyUrl: searchString },
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        if (message === "AgencyUrl  already exist") {
          setCustomerErrorMsg("Cutomer portal URL  already exist");
          setFieldError("agencyUrl", "Cutomer portal URL  already exist");
        }
        if (message === "AgencyUrl  available") {
          setFieldValue("agencyUrl", searchString);
          setCustomerErrorMsg("");
        }
      }
    } catch (error) {}
  };

 const delayedQuery = useCallback(
   (searchString) => {
     debounce(() => getSearchData(searchString), 500)();
   },
   [] // No dependencies, so the callback will be memoized
 );

 useEffect(() => {
   if (searchString) {
     delayedQuery(searchString);
   }
 }, [searchString, delayedQuery]);



  let Change = async (e) => {
    setLoading(true);
    e.preventDefault();
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const formDat = new FormData();
      formDat.append("file", selectedFile);
      const config = {
        method: "POST",
        url: UPLOAD_FILE,
        headers: authHeader(),
        data: formDat,
      };
      try {
        const response = await API(config);
        const { status, filepath } = response.data;
        if (status === "Success") {
          setValues({ ...values, agencyLogo: filepath });
          setflag(false);
          setLoading(false);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }
  };
  let Profile = () => {
    const image = agencyLogo;
    if (image) {
      return image;
    } else {
      return AgencyImage;
    }
  };
  let DeleteProfile = () => {
    setValues({ ...values, agencyLogo: "" });
    setflag(true);
  };

 const GetAgencyDetails = useCallback(async () => {
   //  setLoading(true);
   const config = {
     method: "GET",
     url: AGENCY_LIST,
     headers: authHeader(),
     params: {
       agencyId: agencyid,
     },
   };
   try {
     const response = await API(config);
     const { status, data } = response.data;
     if (status === "Success") {
       const {
         accountHolderName,
         accountNumber,
         address,
         agencyEmail,
         agencyFax,
         agencyName,
         agencyUrl,
         autoApproval,
         bankAddress,
         city,
         createdBy,
         createdByName,
         createdDate,
         ifscCode,
         isDeleted,
         phoneNumber,
         renewalNotifiation,
         routingNumber,
         stateId,
         stateName,
         taxId,
         ttid,
         zip,
       } = data[0];
       console.log("an", accountHolderName, data);
       setValues({
         ...values,
         accountHolderName,
         accountNumber,
         address,
         agencyEmail,
         agencyFax,
         agencyName,
         agencyUrl,
         autoApproval,
         bankAddress,
         city,
         createdBy,
         createdByName,
         createdDate,
         ifscCode,
         isDeleted,
         phoneNumber: "+1 ".concat(phoneNumber),
         renewalNotifiation,
         routingNumber,
         stateId,
         stateName,
         taxId,
         ttid,
         zip,
       });
       setSearchString(agencyUrl);
       //  setisDeleted(data[0].isDeleted);
       //  setLoading(false);
     }
   } catch (error) {
     console.error(error);
   }
 }, [agencyid, authHeader, API, values]);

  useEffect(() => {
    if (agencyid) {
      if (callApiCount === 0) {
        setCallApiCount(1);
        GetAgencyDetails();
      }
   }
 }, [agencyid, GetAgencyDetails]);

  return (
    <div>
      <div className="wrapper">
        {Loading && <CustomPageLoading />}
        <Container fluid>
          <div className="page-title">
            <h4>Update Agency</h4>
            <div className="top-btn">
              <Link
                to={{
                  pathname: "/admin/agency",
                }}
              >
                <Button color="primary">
                  <BackButtonSvg />
                  Back
                </Button>
              </Link>
            </div>
          </div>

          {/* table */}

          <Card body className="mt-4">
            <Form onSubmit={handleSubmit}>
              <div className="form">
                <div className="sub-title">
                  <h5>Personal Details</h5>
                </div>
                <div className="user-box">
                  <img value={agencyLogo} src={Profile()} alt=""/>
                  <p>Agency Profile</p>

                  <div className="upload-btn-wrapper">
                    {flag ? (
                      <>
                        {" "}
                        <button className="upload-btn">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="19.407"
                            height="16.981"
                            viewBox="0 0 19.407 16.981"
                          >
                            <path
                              id="Icon_awesome-camera"
                              data-name="Icon awesome-camera"
                              d="M19.407,6.5V17.412a1.82,1.82,0,0,1-1.819,1.819H1.819A1.82,1.82,0,0,1,0,17.412V6.5A1.82,1.82,0,0,1,1.819,4.676H5.155l.466-1.247a1.817,1.817,0,0,1,1.7-1.179H12.08a1.817,1.817,0,0,1,1.7,1.179l.47,1.247h3.336A1.82,1.82,0,0,1,19.407,6.5Zm-5.155,5.458A4.549,4.549,0,1,0,9.7,16.5,4.552,4.552,0,0,0,14.252,11.954Zm-1.213,0A3.336,3.336,0,1,1,9.7,8.618,3.341,3.341,0,0,1,13.039,11.954Z"
                              transform="translate(0 -2.25)"
                              fill="#d51d1d"
                            />
                          </svg>
                        </button>
                        <Input
                          type="file"
                          name="profileImage"
                          onChange={Change}
                        />
                      </>
                    ) : (
                      <Button
                        onClick={DeleteProfile}
                        className="table-btn"
                        color="link"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10.071"
                          height="12.949"
                          viewBox="0 0 10.071 12.949"
                        >
                          <path
                            id="Icon_material-delete"
                            data-name="Icon material-delete"
                            d="M8.219,16.01a1.443,1.443,0,0,0,1.439,1.439h5.755a1.443,1.443,0,0,0,1.439-1.439V7.378H8.219ZM17.571,5.219H15.054L14.334,4.5h-3.6l-.719.719H7.5V6.658H17.571Z"
                            transform="translate(-7.5 -4.5)"
                            fill="#c72e39"
                          />
                        </svg>
                      </Button>
                    )}
                  </div>
                </div>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="agencyName">Agency Name</Label>
                      <Input
                        type="text"
                        name="agencyName"
                        id="agencyName"
                        value={agencyName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.agencyName && errors.agencyName ? true : false
                        }
                        placeholder="Agency Name"
                      />
                      <FormFeedback>
                        {touched.agencyName && errors.agencyName
                          ? errors.agencyName
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="email">Agency Email</Label>
                      <Input
                        type="email"
                        name="agencyEmail"
                        id="email"
                        value={agencyEmail}
                        disabled
                        // onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.agencyEmail && errors.agencyEmail
                            ? true
                            : false
                        }
                        placeholder="Agency Email"
                      />
                      <FormFeedback>
                        {touched.agencyEmail && errors.agencyEmail
                          ? errors.agencyEmail
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="phoneNumber">Phone Number</Label>
                      <Input
                        type="tel"
                        name="phoneNumber"
                        id="phoneNumber"
                        value={phoneNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.phoneNumber && errors.phoneNumber
                            ? true
                            : false
                        }
                        placeholder="Phone Number"
                      />
                      <FormFeedback>
                        {touched.phoneNumber && errors.phoneNumber
                          ? errors.phoneNumber
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="fax">
                        Agency Fax
                        <Tooltip
                          isOpen={id === "agencyfax" && tooltipOpen}
                          target={"agencyfax"}
                          toggle={() => toggle("agencyfax")}
                        >
                          Agency fax number
                        </Tooltip>
                        <span id={"agencyfax"}>
                          <Info />
                        </span>{" "}
                      </Label>
                      <Input
                        type="text"
                        name="agencyFax"
                        id="fax"
                        value={agencyFax}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        invalid={
                          touched.agencyFax && errors.agencyFax ? true : false
                        }
                        placeholder="Agency Fax"
                      />
                      <FormFeedback>
                        {touched.agencyFax && errors.agencyFax
                          ? errors.agencyFax
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="address">Address</Label>
                      <Input
                        type="textarea"
                        name="address"
                        id="address"
                        value={address}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        invalid={
                          touched.address && errors.address ? true : false
                        }
                        placeholder="Address"
                      />
                      <FormFeedback>
                        {touched.address && errors.address
                          ? errors.address
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="city">City</Label>
                      <Input
                        type="text"
                        name="city"
                        id="city"
                        value={city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={touched.city && errors.city ? true : false}
                        placeholder="City"
                      />
                      <FormFeedback>
                        {touched.city && errors.city ? errors.city : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="state">State</Label>
                      <Input
                        type="select"
                        name="stateId"
                        id="state"
                        value={stateId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.stateId && errors.stateId ? true : false
                        }
                        placeholder="State"
                      >
                        <option key="1" value="">
                          Select State
                        </option>
                        ;
                        {stateList.map((list) => {
                          const { stateId, stateName } = list;

                          return (
                            <option key={stateId} value={stateId}>
                              {stateName}
                            </option>
                          );
                        })}
                      </Input>
                      <FormFeedback>
                        {touched.stateId && errors.stateId
                          ? errors.stateId
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="zip">Zip</Label>
                      <Input
                        type="tel"
                        name="zip"
                        id="zip"
                        value={zip}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={touched.zip && errors.zip ? true : false}
                        placeholder="Zip"
                      />
                      <FormFeedback>
                        {touched.zip && errors.zip ? errors.zip : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="locationCode">
                        Location Code
                        <Tooltip
                          isOpen={id === "locationcode" && tooltipOpen}
                          target={"locationcode"}
                          toggle={() => toggle("locationcode")}
                        >
                          Assigned agency location code
                        </Tooltip>
                        <span id={"locationcode"}>
                          <Info />
                        </span>{" "}
                      </Label>
                      <Input
                        type="tel"
                        name="ttid"
                        id="locationCode"
                        value={ttid}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={touched.ttid && errors.ttid ? true : false}
                        placeholder="Location Code"
                      />
                      <FormFeedback>
                        {touched.ttid && errors.ttid ? errors.ttid : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    <FormGroup>
                      <Label for="taxid">TAXID</Label>
                      <Input
                        type="string"
                        name="taxId"
                        id="taxid"
                        value={taxId}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={touched.taxId && errors.taxId ? true : false}
                        placeholder="TAXID"
                      />
                      <FormFeedback>
                        {touched.taxId && errors.taxId ? errors.taxId : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="agencyUrl">
                        Customer Portal URL
                        <Tooltip
                          isOpen={id === "id" + 1 && tooltipOpen}
                          target={"id" + 1}
                          toggle={() => toggle("id" + 1)}
                        >
                          Url for customer login portal
                        </Tooltip>
                        <span id={"id" + 1}>
                          <Info />
                        </span>{" "}
                      </Label>
                      <InputGroup>
                        <Input
                          type="string"
                          name="agencyUrl"
                          id="agencyUrl"
                          value={searchString}
                          onChange={(e) => {
                            handleSearch(e);
                            setFieldTouched("agencyUrl", true);
                          }}
                          onBlur={handleBlur}
                          invalid={
                            touched.agencyUrl && errors.agencyUrl ? true : false
                          }
                          placeholder="Customer Portal URL"
                        />
                      </InputGroup>
                      <FormFeedback
                        style={{
                          display:
                            touched.agencyUrl || errors.agencyUrl
                              ? "block"
                              : "none",
                        }}
                      >
                        {console.log(touched.agencyUrl, '-ad--', errors.agencyUrl, '--d---', customerErrorMsg)}
                        {(touched.agencyUrl && errors.agencyUrl) || (customerErrorMsg)
                          ? errors.agencyUrl ? errors.agencyUrl : customerErrorMsg
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    {/* <FormGroup>
                      <Label for="kennelLicenceCount">
                        Kennel License Count
                        <Tooltip
                          isOpen={id === "kennel" && tooltipOpen}
                          target={"kennel"}
                          toggle={() => toggle("kennel")}
                        >
                          Total number of kennel licenses
                        </Tooltip>
                        <span id={"kennel"}>
                          <Info />
                        </span>
                      </Label>
                      <Input
                        type="text"
                        name="kennelLicenceCount"
                        id="kennelLicenceCount"
                        value={kennelLicenceCount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.kennelLicenceCount &&
                          errors.kennelLicenceCount
                            ? true
                            : false
                        }
                        placeholder="Kennel License Count"
                      />
                      <FormFeedback>
                        {touched.kennelLicenceCount && errors.kennelLicenceCount
                          ? errors.kennelLicenceCount
                          : ""}
                      </FormFeedback>
                    </FormGroup> */}
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="renewalNotifiation">
                        Renewal Notification
                        <Tooltip
                          isOpen={id === "renewal" && tooltipOpen}
                          target={"renewal"}
                          toggle={() => toggle("renewal")}
                        >
                          List number of days between renewal notifications are
                          sent
                        </Tooltip>
                        <span id={"renewal"}>
                          <Info />
                        </span>
                      </Label>
                      <InputGroup>
                        <Input
                          type="text"
                          name="renewalNotifiation"
                          id="renewalNotifiation"
                          value={renewalNotifiation}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          invalid={
                            touched.renewalNotifiation &&
                            errors.renewalNotifiation
                              ? true
                              : false
                          }
                          placeholder="Renewal Notification"
                        />
                        <>
                          <InputGroupText>Days</InputGroupText>
                        </>
                      </InputGroup>
                      <FormFeedback
                        style={{
                          display:
                            touched.renewalNotifiation &&
                            errors.renewalNotifiation
                              ? "block"
                              : "none",
                        }}
                      >
                        {touched.renewalNotifiation && errors.renewalNotifiation
                          ? errors.renewalNotifiation
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup check className="mt-lg-5">
                      <Label check>
                        <Input
                          type="checkbox"
                          name="autoApproval"
                          id="autoApproval"
                          value={autoApproval}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          invalid={
                            touched.autoApproval && errors.autoApproval
                              ? true
                              : false
                          }
                          placeholder="Auto Approval"
                        />
                        Auto Approval
                        <Tooltip
                          isOpen={id === "id" + 2 && tooltipOpen}
                          target={"id" + 2}
                          toggle={() => toggle("id" + 2)}
                        >
                          Check box to turn on Auto Approval
                        </Tooltip>
                        <span id={"id" + 2}>
                          <Info />
                        </span>
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <div className="sub-title mt-5">
                  <h5>
                    Bank Details
                    <Tooltip
                      isOpen={id === "bankdetails" && tooltipOpen}
                      target={"bankdetails"}
                      toggle={() => toggle("bankdetails")}
                    >
                      Bank information for processing payments
                    </Tooltip>
                    <span id={"bankdetails"}>
                      <Info />
                    </span>{" "}
                  </h5>
                </div>

                <Row>
                  <Col md="4">
                    <FormGroup>
                      <Label for="accountNumber">Account Number</Label>
                      <Input
                        type="tel"
                        name="accountNumber"
                        id="accountNumber"
                        value={accountNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.accountNumber && errors.accountNumber
                            ? true
                            : false
                        }
                        placeholder="Account Number"
                      />
                      <FormFeedback>
                        {touched.accountNumber && errors.accountNumber
                          ? errors.accountNumber
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="accountHolderName">Holder Name</Label>
                      <Input
                        type="tel"
                        name="accountHolderName"
                        id="accountHolderName"
                        value={accountHolderName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.accountHolderName && errors.accountHolderName
                            ? true
                            : false
                        }
                        placeholder="Holder Name"
                      />
                      <FormFeedback>
                        {touched.accountHolderName && errors.accountHolderName
                          ? errors.accountHolderName
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  {/* <Col md="4">
                    <FormGroup>
                      <Label for="ifscCode">IFSC Code</Label>
                      <Input
                        type="tel"
                        name="ifscCode"
                        id="ifscCode"
                        value={ifscCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.ifscCode && errors.ifscCode ? true : false
                        }
                        placeholder="IFSC Code"
                      />
                      <FormFeedback>
                        {touched.ifscCode && errors.ifscCode
                          ? errors.ifscCode
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col> */}
                  <Col md="4">
                    <FormGroup>
                      <Label for="bankAddress">Bank Address</Label>
                      <Input
                        type="tel"
                        name="bankAddress"
                        id="bankAddress"
                        value={bankAddress}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.bankAddress && errors.bankAddress
                            ? true
                            : false
                        }
                        placeholder="Bank Address"
                      />
                      <FormFeedback>
                        {touched.bankAddress && errors.bankAddress
                          ? errors.bankAddress
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                  <Col md="4">
                    <FormGroup>
                      <Label for="routingNumber">
                        Routing Number
                        <Tooltip
                          isOpen={id === "routingnumber" && tooltipOpen}
                          target={"routingnumber"}
                          toggle={() => toggle("routingnumber")}
                        >
                          Bank account routing information
                        </Tooltip>
                        <span id={"routingnumber"}>
                          <Info />
                        </span>{" "}
                      </Label>
                      <Input
                        type="text"
                        name="routingNumber"
                        id="routingNumber"
                        value={routingNumber}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          touched.routingNumber && errors.routingNumber
                            ? true
                            : false
                        }
                        placeholder="Routing Number"
                      />
                      <FormFeedback>
                        {touched.routingNumber && errors.routingNumber
                          ? errors.routingNumber
                          : ""}
                      </FormFeedback>
                    </FormGroup>
                  </Col>
                </Row>
              </div>

              <Button color="primary" type="submit" className="d-block m-auto">
                Update
              </Button>
            </Form>
          </Card>
        </Container>
      </div>
    </div>
  );
}
